import type { SubjectTypeDefinitionPayload } from '@Application/SubjectTypeDefinitions/Actions/subjectTypeDefinitionsFetched';
import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';
import SubjectSpeakerRoleView from '@UI/Store/SubjectTypes/Views/SubjectSpeakerRoleView';
import SubjectTypeWordingView from '@UI/Store/SubjectTypes/Views/SubjectTypeWordingView';
import SubjectFieldDraftView from '@UI/Store/SubjectTypeDefinitions/Views/SubjectFieldDraftView';
import SubjectTypeGrantView from '@UI/Store/SubjectTypeDefinitions/Views/SubjectTypeGrantView';

/** A dossier type as the administration sees it: archived fields included, ordered as defined. */
class SubjectTypeDefinitionView {
	readonly id: number;
	readonly key: string;
	readonly archivedAt: string | null;
	readonly isUsed: boolean;
	readonly wording: SubjectTypeWordingView;
	readonly icon: LabeledValueView;
	readonly color: LabeledValueView;
	readonly informationMode: LabeledValueView;
	readonly membersCanShare: boolean;
	readonly about: readonly LabeledValueView[];
	readonly fields: readonly SubjectFieldDraftView[];
	readonly speakerRoles: readonly SubjectSpeakerRoleView[];
	readonly usableBy: readonly SubjectTypeGrantView[];
	readonly workflowKeys: readonly string[];

	constructor(payload: SubjectTypeDefinitionPayload) {
		this.id = payload.id;
		this.key = payload.key;
		this.archivedAt = payload.archivedAt;
		this.isUsed = payload.isUsed;
		this.wording = new SubjectTypeWordingView(payload.wording);
		this.icon = new LabeledValueView(payload.icon);
		this.color = new LabeledValueView(payload.color);
		this.informationMode = new LabeledValueView(payload.informationMode);
		this.membersCanShare = payload.membersCanShare;
		this.about = payload.about.map((entry) => new LabeledValueView(entry));
		this.fields = payload.fields.map(
			(field) =>
				new SubjectFieldDraftView({
					key: field.key,
					label: field.label,
					nature: field.nature.value,
					natureLabel: field.nature.label,
					options: field.options,
					required: field.required,
					sentToAi: field.sentToAi,
					archived: field.archived,
				}),
		);
		this.speakerRoles = payload.speakerRoles.map((role) => new SubjectSpeakerRoleView(role));
		this.usableBy = payload.usableBy.map((grant) => new SubjectTypeGrantView(grant));
		this.workflowKeys = [...payload.workflowKeys];

		Object.freeze(this);
	}

	get isArchived(): boolean {
		return this.archivedAt !== null;
	}
}

export default SubjectTypeDefinitionView;
